import { Navigate, useLocation } from "react-router-dom";
import { useUser } from "./useUser";

// Route guard. While /me is loading, render nothing (avoids flicker into
// /login on every route mount). On unauthenticated, redirect to /login
// preserving the attempted path as ?returnTo so post-OAuth round-trip lands
// the user where they were trying to go.
export function RequireAuth({ children }: { children: React.ReactNode }) {
  const { data: user, isLoading } = useUser();
  const location = useLocation();

  if (isLoading) return null;
  if (!user) {
    const returnTo = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?returnTo=${returnTo}`} replace />;
  }
  return <>{children}</>;
}
